import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Config } from '../config/env.config';
import { BaseHttpService } from '../base/_base-http.service';
import { contentHeaders } from 'common/headers';
import * as _ from 'lodash';
import {catchError, map} from 'rxjs/operators';
import {of} from 'rxjs/internal/observable/of';

@Injectable()
export class TeamService extends BaseHttpService {

  private rootUrl: string = 'team';

  fetch(brandId: string): Observable<any> {
    return this.http.get(`${Config.API}/${this.rootUrl}/${brandId}`)
      .pipe(map( team => {
        _.map(team, (member: any) => {
          member.name = member.first_name ? member.first_name : '';
          member.name += member.last_name ? ' ' + member.last_name : '';
          member.initials = member.first_name ? member.first_name.charAt(0).toUpperCase() : '';
          member.initials += member.last_name ? member.last_name.charAt(0).toUpperCase() : '';
          if (member.type === 'support') {
            member.text = 'This is support';
          }
          if (!member.last_accessed) {
            if (!member.user_id) {
              member.last_accessed = 'Pending';
            } else {
              member.last_accessed = 'Has not logged in';
            }
          }

        });
        return team;
      }), catchError(this.handleError.bind(this)));
  }

  removeMembers(brandId: string, userIds: Array<number>, userInviteIds: Array<number>) {
    const body = JSON.stringify({userIds: userIds, userInviteIds: userInviteIds});
    return this.http.put(`${Config.API}/${this.rootUrl}/${brandId}/remove`, body, {headers: contentHeaders})
        .pipe(catchError(this.handleError.bind(this)));
  }

  put(brandId: string, data: any): Observable<any> {
    return of({});
  }
}
